import styles from './HomePage.module.scss';
import ApiInterface from "@/commons/api/ApiInterface"
import React, {useEffect, useState} from "react";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";
import Redirects from "@/commons/utils/Redirects"
import {useNavigate} from "react-router-dom";
import {DirectoryIcon, FileIcon, TicketIcon, UserIcon} from "@/commons/resources/images/AdminIcons";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";
import {useUser} from "@/contexts/UserContext";
import Sections from "@/admin/sections/Sections";

const AdminPage = () => {
    const {accountData} = useUser();
    const navigate = useNavigate();

    return (
        <>
            <div className={"page__body"}>
                <Header/>
                <div className={"page__content"}>
                    <div>
                        <h3>Pagina Admin</h3>
                        <div className={styles.content__global}>
                            <div>
                                <p>Benvenuto {accountData?.username}, <br/>
                                    Questo è il tuo pannello di controllo di EBLCraft. <br/>
                                    Da qui, avrai un accesso completo a tutti gli strumenti di gestione e
                                    amministrazione dei siti EBLCraft.</p>
                                <br/>
                            </div>
                        </div>
                        <div className={styles.categories}>
                            <Sections/>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
}
export default AdminPage;